<script setup lang="ts">
const t2 = useT2({})
const { seller } = useSeller('server')
</script>

<template>
  <AppMenu :title="t2('Terms and conditions')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.termsAndConditions?._id" />
    </template>
  </AppMenu>
</template>
